<script setup>
import {ElBadge} from 'element-plus';// TODO: Replace badge
import 'element-plus/es/components/badge/style/css';
import DpImg from '../DpImg';
import get from 'lodash/get';
import { computed, inject } from 'vue';

const props = defineProps({
  flagISOCode: {
    type: String
  }
});

import {useAuthStore} from '@dutypay/store-modules'
const authStore = useAuthStore()
const user = authStore.user;
const hasUserName = authStore.hasUserName;

const userName = computed(() => {
  return (hasUserName) ? `${user.name.given} ${user.name.family}` : '';
});
const showNotification = computed(() => {
  return false;
});

const composables = inject('composables')
const { getJurisdictionByLocale } = composables.useJurisdictionSwitch()
</script>

<template>
  <div class="avatar__container">
    <el-badge
        :hidden="!showNotification"
        is-dot
        class="item">
      <div class="avatar__wrapper">
        <div class="avatar">
          <DpImg hsId="ff0d5e0e-af9c-4fe5-966b-8979af756981" class="avatar__image" :alt="userName"
                 :srcset="[
                    {resourceSize: 'height/24', renderSize: '1x'},
                    {resourceSize: 'height/48', renderSize: '2x'},
                  ]"/>
        </div>
        <div v-if="get(getJurisdictionByLocale($i18n.locale), 'flagISOCode', false)" class="avatar-flag">
          <DpFlag class="avatar-flag__flag-icon" :flagISOCode="getJurisdictionByLocale($i18n.locale).flagISOCode" />
        </div>
      </div>
    </el-badge>
    <span class="clear-both"></span>
  </div>
</template>

<style scoped lang="scss">
.avatar__container {
  cursor: pointer;
}

.avatar__wrapper {
  position: relative;
  border: 2px solid #E3E3E3;
  border-radius: 50%;
  width: 26px;
  height: 26px;
}

.avatar {
  position: relative;
  background: #E3E3E3;
  margin-inline-start: 1px;
  transform: translateY(1px);
  border-radius: 50%;
  overflow: hidden;
  width: 24px;
  height: 24px;
}

picture.avatar__image {
  source, img {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.avatar-flag {
  position: absolute;
  height: 13px;
  width: 13px;
  bottom: -2px;
  inset-inline-end: 0;

  .avatar-flag__flag-icon {
    position: absolute;
    height: 13px;
    width: 13px;
    border-radius: 50%;
    box-shadow: 0 9px 12px 0 rgba(0,0,0,0.20);
  }
}
</style>
